document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-root]').forEach(root => {
    const form = root.querySelector('#amada-product-form');
    if (!form) return;

    const variantsNode = form.querySelector('[data-variants-json]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const idInput = form.querySelector('[data-variant-id]');
    const quantityInput = form.querySelector('[data-quantity]');
    const priceNode = root.querySelector('[data-price]');
    const compareNode = root.querySelector('[data-compare]');
    const saveNode = root.querySelector('[data-save]');
    const atc = form.querySelector('[data-atc]');
    const atcLabel = form.querySelector('[data-atc-label]');
    const atcPrice = form.querySelector('[data-atc-price]');
    const sticky = document.querySelector('[data-sticky-atc]');
    const stickySubmit = sticky?.querySelector('[data-sticky-submit]');
    const stickyLabel = sticky?.querySelector('[data-sticky-label]');
    const stickyPrice = sticky?.querySelector('[data-sticky-price]');
    const stickyCompare = sticky?.querySelector('[data-sticky-compare]');
    const stickySave = sticky?.querySelector('[data-sticky-save]');
    const bumpCard = form.querySelector('[data-bump-card]');
    const bumpCheckbox = form.querySelector('[data-bump-checkbox]');
    // V2 (22/10/2026): complemento da familia abaixo do limite de frete (caixa desmarcada). Preco, variante e limite vem do Liquid.
    const compCard = form.querySelector('[data-comp-card]');
    const compCheckbox = form.querySelector('[data-comp-checkbox]');
    const currency = window.Shopify?.currency?.active || 'USD';
    const locale = document.documentElement.lang || 'en-US';
    const money = cents => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    const selectedTier = () => form.querySelector('[data-quantity-tier].is-active') || form.querySelector('[data-quantity-tier]');
    const selectedQuantity = () => Number(quantityInput?.value || selectedTier()?.dataset.quantityTier || 1);
    const selectedDiscount = () => Number(selectedTier()?.dataset.discount || 0);
    // Botão no estilo do mockup: nome do pacote quando leva mais de uma peça
    const ctaLabel = () => selectedQuantity() > 1 ? 'ADD SET TO BAG' : 'ADD TO BAG';
    // Contrato V2: uma embalagem para CADA colar (900 / 1800 / 2700).
    const selectedBumpPrice = () => bumpCheckbox?.checked ? Number(bumpCheckbox.dataset.bumpPrice || 0) * selectedQuantity() : 0;
    // O complemento entra uma vez so (nao multiplica pela faixa) e fica fora do desconto por quantidade.
    const selectedCompPrice = () => compCheckbox?.checked ? Number(compCheckbox.dataset.compPrice || 0) : 0;
    // Se so a(s) peca(s) ja chega(m) ao limite de frete, a oferta do complemento some e a caixa desmarca.
    function syncComp(variant) {
      if (!compCard || !compCheckbox || !variant) return;
      const quantity = selectedQuantity();
      const discount = selectedDiscount();
      const productTotal = quantity * (Number(variant.price) - Math.round(Number(variant.price) * discount / 100));
      const reached = productTotal >= Number(compCheckbox.dataset.compThreshold || 0);
      if (reached && compCheckbox.checked) { compCheckbox.checked = false; compCard.classList.remove('is-selected'); }
      if (reached) compCard.style.setProperty('display', 'none', 'important'); else compCard.style.removeProperty('display');
    }

    function selectionPricing(variant = selectedVariant()) {
      if (!variant) return { total: 0, compare: 0, save: 0 };
      const quantity = selectedQuantity();
      const discount = selectedDiscount();
      const productTotal = quantity * (Number(variant.price) - Math.round(Number(variant.price) * discount / 100));
      const bumpTotal = selectedBumpPrice() + selectedCompPrice();
      const basePrice = Number(variant.compare_at_price) > Number(variant.price) ? Number(variant.compare_at_price) : Number(variant.price);
      const compare = basePrice * quantity + bumpTotal;
      const total = productTotal + bumpTotal;
      return { total, compare, save: Math.max(0, compare - total) };
    }

    function refreshStickyTotal(variant = selectedVariant()) {
      syncComp(variant);
      const pricing = selectionPricing(variant);
      if (stickyPrice) stickyPrice.textContent = money(pricing.total);
      if (atcPrice) atcPrice.textContent = money(pricing.total) + ' ' + currency;
      if (stickyCompare) {
        stickyCompare.hidden = pricing.save <= 0;
        stickyCompare.textContent = money(pricing.compare);
      }
      if (stickySave) {
        stickySave.hidden = pricing.save <= 0;
        stickySave.textContent = 'Save ' + money(pricing.save);
      }
    }

    function addBusinessDays(start, amount) {
      const date = new Date(start);
      let added = 0;
      while (added < amount) {
        date.setDate(date.getDate() + 1);
        const day = date.getDay();
        if (day !== 0 && day !== 6) added += 1;
      }
      return date;
    }

    function selectedVariant() {
      const selected = [...form.querySelectorAll('[data-option-index]')].map(group => group.querySelector('input:checked')?.value);
      return variants.find(item => item.options.every((value, index) => value === selected[index])) || variants[0];
    }

    function updateTierTotals(unitPrice) {
      form.querySelectorAll('[data-quantity-tier]').forEach(tier => {
        const quantity = Number(tier.dataset.quantityTier || 1);
        const discount = Number(tier.dataset.discount || 0);
        const compare = unitPrice * quantity;
        const total = quantity * (unitPrice - Math.round(unitPrice * discount / 100));
        const saving = compare - total;
        const totalNode = tier.querySelector('[data-tier-total]');
        const savingNode = tier.querySelector('[data-tier-save]');
        if (totalNode) totalNode.textContent = money(total);
        if (savingNode) savingNode.textContent = `Save ${money(saving)}`;
      });
    }

    function selectVariant() {
      const variant = selectedVariant();
      if (!variant) return;
      idInput.value = variant.id;
      priceNode.textContent = money(variant.price);
      updateTierTotals(Number(variant.price));
      const discounted = variant.compare_at_price && variant.compare_at_price > variant.price;
      compareNode.hidden = !discounted;
      saveNode.hidden = !discounted;
      if (discounted) {
        compareNode.textContent = money(variant.compare_at_price);
        saveNode.textContent = 'Save ' + money(variant.compare_at_price - variant.price);
      }
      refreshStickyTotal(variant);
      atc.disabled = !variant.available;
      if (stickySubmit) stickySubmit.disabled = !variant.available;
      atcLabel.textContent = variant.available ? ctaLabel() : 'SOLD OUT';
      if (stickyLabel) stickyLabel.textContent = variant.available ? ctaLabel() : 'SOLD OUT';
    }

    form.addEventListener('change', event => {
      if (event.target.matches('[name^="option-"]')) { selectVariant(); if (window.amadaIrParaFotoDaVariante) window.amadaIrParaFotoDaVariante(root, selectedVariant()); }
    });

    form.querySelectorAll('[data-quantity-tier]').forEach(button => button.addEventListener('click', () => {
      form.querySelectorAll('[data-quantity-tier]').forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      quantityInput.value = button.dataset.quantityTier;
      refreshStickyTotal();
      if (!atc.disabled) {
        atcLabel.textContent = ctaLabel();
        if (stickyLabel) stickyLabel.textContent = ctaLabel();
      }
    }));

    bumpCheckbox?.addEventListener('change', () => {
      bumpCard?.classList.toggle('is-selected', bumpCheckbox.checked);
      refreshStickyTotal();
    });

    compCheckbox?.addEventListener('change', () => {
      compCard?.classList.toggle('is-selected', compCheckbox.checked);
      refreshStickyTotal();
    });

    const initialInput = form.querySelector('input[name="properties[Initial]"]');
    const initialOutput = root.querySelector('[data-preview-initial-output]');
    initialInput?.addEventListener('input', () => {
      initialOutput.textContent = (initialInput.value || 'A').slice(0, 1).toUpperCase();
    });

    const nameInput = form.querySelector('[data-preview-name]');
    const verseInput = form.querySelector('[data-preview-verse]');
    const nameOutput = root.querySelector('[data-preview-name-output]');
    const verseOutput = root.querySelector('[data-preview-verse-output]');
    const refreshEngraving = () => {
      if (nameOutput) nameOutput.textContent = nameInput?.value.trim() || 'Your name';
      if (verseOutput) verseOutput.textContent = verseInput?.value.trim() || 'Your verse';
    };
    nameInput?.addEventListener('input', refreshEngraving);
    verseInput?.addEventListener('input', refreshEngraving);

    function prepareSections() {
      const sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      return sections;
    }

    async function openCart(responseJson, sourceElement) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && window.themeVariables?.settings?.cartType === 'drawer') {
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('The cart could not be refreshed.');
        const cartContent = await cartResponse.json();
        cartContent.sections = responseJson.sections;
        sourceElement.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: { items: responseJson.hasOwnProperty('items') ? responseJson.items : [responseJson], cart: cartContent },
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cartContent },
        }));
      } else {
        window.location.assign('/cart');
      }
    }

    async function addItems(items, sourceElement) {
      const sections = prepareSections();
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.Shopify?.routes?.root || '/' }),
      });
      const responseJson = await response.json();
      if (!response.ok) { const addError = new Error(responseJson?.description || 'The item could not be added.'); addError.addFailed = true; throw addError; }
      await openCart(responseJson, sourceElement);
      return responseJson;
    }

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const properties = {};
      new FormData(form).forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && String(value).trim()) properties[match[1]] = value;
      });
      const items = [{ id: Number(idInput.value), quantity: Number(quantityInput.value || 1), properties }];
      if (bumpCheckbox?.checked && Number(bumpCheckbox.dataset.bumpVariant)) {
        items.push({ id: Number(bumpCheckbox.dataset.bumpVariant), quantity: Number(quantityInput.value || 1), properties: { 'Added with': root.dataset.productTitle || 'Amada jewelry' } });
      }
      if (compCheckbox?.checked && Number(compCheckbox.dataset.compVariant)) {
        items.push({ id: Number(compCheckbox.dataset.compVariant), quantity: 1, properties: { 'Added with': root.dataset.productTitle || 'Amada jewelry' } });
      }
      atc.disabled = true;
      if (stickySubmit) stickySubmit.disabled = true;
      sticky?.classList.add('is-loading');
      atcLabel.textContent = 'ADDING...';
      if (stickyLabel) stickyLabel.textContent = 'ADDING...';
      try {
        try {
          await addItems(items, form);
        } catch (addError) {
          // Se o complemento travar o cart/add, desmarca e repete uma vez so sem ele (peca principal e caixa de presente seguem).
          const compIndex = compCheckbox?.checked ? items.findIndex(item => item.id === Number(compCheckbox.dataset.compVariant)) : -1;
          if (!addError.addFailed || compIndex < 0) throw addError;
          compCheckbox.checked = false;
          compCard?.classList.remove('is-selected');
          refreshStickyTotal();
          items.splice(compIndex, 1);
          await addItems(items, form);
        }
        atcLabel.textContent = ctaLabel();
        if (stickyLabel) stickyLabel.textContent = ctaLabel();
      } catch (error) {
        atcLabel.textContent = 'TRY AGAIN';
        if (stickyLabel) stickyLabel.textContent = 'TRY AGAIN';
        window.setTimeout(() => {
          atcLabel.textContent = ctaLabel();
          if (stickyLabel) stickyLabel.textContent = ctaLabel();
        }, 2200);
      } finally {
        atc.disabled = !selectedVariant()?.available;
        if (stickySubmit) stickySubmit.disabled = atc.disabled;
        sticky?.classList.remove('is-loading');
      }
    });


    const galleryCurrent = root.querySelector('[data-gallery-current]');
    const gallerySlides = [...root.querySelectorAll('[data-gallery-slide]')];
    const galleryThumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const galleryWarmups = new WeakMap();

    const warmGalleryImage = (index, priority = 'low') => {
      const image = gallerySlides[index]?.querySelector('img');
      if (!image) return Promise.resolve();
      image.loading = 'eager';
      image.fetchPriority = priority;
      if (galleryWarmups.has(image)) return galleryWarmups.get(image);

      const decode = () => typeof image.decode === 'function' ? image.decode().catch(() => {}) : Promise.resolve();
      const ready = image.complete && image.naturalWidth
        ? decode()
        : new Promise(resolve => {
            image.addEventListener('load', () => decode().then(resolve), { once: true });
            image.addEventListener('error', resolve, { once: true });
          });
      galleryWarmups.set(image, ready);
      return ready;
    };

    const warmGalleryNeighbors = index => {
      warmGalleryImage(index + 1);
      warmGalleryImage(index - 1);
    };

    const heroImage = gallerySlides[0]?.querySelector('img');
    const warmFirstAlternates = () => {
      warmGalleryImage(1);
      const warmThird = () => warmGalleryImage(2);
      if ('requestIdleCallback' in window) window.requestIdleCallback(warmThird, { timeout: 1400 });
      else window.setTimeout(warmThird, 350);
    };
    if (heroImage?.complete && heroImage.naturalWidth) warmFirstAlternates();
    else heroImage?.addEventListener('load', warmFirstAlternates, { once: true });

    // Galeria com rolagem lateral nativa (scroll-snap): a trilha rola; miniaturas, setas e
    // contador acompanham. Miniatura rola so a faixa dela, sem puxar a pagina.
    let galleryIndex = 0;
    const galleryTrack = root.querySelector('[data-gallery-track]');
    const marcarAtivo = (index) => {
      galleryIndex = index;
      gallerySlides.forEach(slide => {
        const active = Number(slide.dataset.gallerySlide) === index;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelector('video')?.pause();
      });
      galleryThumbs.forEach(item => {
        const active = Number(item.dataset.galleryThumb) === index;
        item.classList.toggle('is-active', active);
        if (active && item.parentElement) {
          const faixa = item.parentElement;
          const alvo = item.offsetLeft - (faixa.clientWidth - item.clientWidth) / 2;
          faixa.scrollTo({ left: Math.max(0, alvo), behavior: 'smooth' });
        }
      });
      if (galleryCurrent) galleryCurrent.textContent = String(index + 1).padStart(2, '0');
      warmGalleryNeighbors(index);
    };
    const goToSlide = (target) => {
      const total = gallerySlides.length;
      if (!total) return;
      const index = Math.max(0, Math.min(total - 1, target));
      warmGalleryImage(index, 'high');
      if (galleryTrack) galleryTrack.scrollTo({ left: index * galleryTrack.clientWidth, behavior: 'smooth' });
      marcarAtivo(index);
    };
    root.amadaGoToSlide = goToSlide;

    galleryThumbs.forEach(thumb => {
      const targetIndex = Number(thumb.dataset.galleryThumb);
      const anticipate = () => warmGalleryImage(targetIndex, 'high');
      thumb.addEventListener('pointerenter', anticipate, { passive: true });
      thumb.addEventListener('pointerdown', anticipate, { passive: true });
      thumb.addEventListener('focus', anticipate, { passive: true });
      thumb.addEventListener('click', () => goToSlide(targetIndex));
    });

    if (galleryTrack && gallerySlides.length > 1) {
      // a rolagem (dedo, trackpad, mouse) define a foto ativa
      let quadro = 0;
      galleryTrack.addEventListener('scroll', () => {
        if (quadro) return;
        quadro = window.requestAnimationFrame(() => {
          quadro = 0;
          const largura = galleryTrack.clientWidth || 1;
          const index = Math.max(0, Math.min(gallerySlides.length - 1, Math.round(galleryTrack.scrollLeft / largura)));
          if (index !== galleryIndex) { warmGalleryImage(index, 'high'); marcarAtivo(index); }
        });
      }, { passive: true });

      galleryTrack.querySelectorAll('img').forEach(img => img.addEventListener('dragstart', ev => ev.preventDefault()));

      // desktop: arrastar com o mouse tambem passa as fotos
      let arrasto = null;
      galleryTrack.addEventListener('pointerdown', (e) => {
        warmGalleryNeighbors(galleryIndex);
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        arrasto = { x: e.clientX, left: galleryTrack.scrollLeft, moveu: false };
      });
      window.addEventListener('pointermove', (e) => {
        if (!arrasto) return;
        const dx = e.clientX - arrasto.x;
        if (Math.abs(dx) > 4) { arrasto.moveu = true; galleryTrack.classList.add('is-dragging'); }
        if (arrasto.moveu) galleryTrack.scrollLeft = arrasto.left - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!arrasto) return;
        const moveu = arrasto.moveu;
        arrasto = null;
        galleryTrack.classList.remove('is-dragging');
        if (moveu) goToSlide(Math.round(galleryTrack.scrollLeft / (galleryTrack.clientWidth || 1)));
      });

      // teclado: setas quando a galeria esta em foco
      galleryTrack.setAttribute('tabindex', '0');
      galleryTrack.setAttribute('role', 'group');
      galleryTrack.setAttribute('aria-label', 'Product images, scroll sideways or use the arrow keys');
      galleryTrack.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goToSlide(galleryIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goToSlide(galleryIndex - 1); }
      });
    }

    if (sticky && stickySubmit) {
      const mobile = window.matchMedia('(max-width: 599px)');
      const setStickyVisibility = show => {
        const visible = Boolean(show && mobile.matches);
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', String(!visible));
      };
      const syncStickyVisibility = () => setStickyVisibility(atc.getBoundingClientRect().bottom < 0);
      let stickyFrame = 0;
      const queueStickySync = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(() => {
          stickyFrame = 0;
          syncStickyVisibility();
        });
      };
      const observer = new IntersectionObserver(queueStickySync, { threshold: 0.1 });
      observer.observe(atc);
      window.addEventListener('scroll', queueStickySync, { passive: true });
      window.addEventListener('resize', queueStickySync, { passive: true });
      mobile.addEventListener?.('change', queueStickySync);
      stickySubmit.addEventListener('click', () => form.requestSubmit(atc));
      syncStickyVisibility();
    }

    selectVariant();
    // Voltar do navegador restaura caixas marcadas: realinha cartoes, total e barra fixa (inclui caixa de presente e complemento)
    window.addEventListener('pageshow', () => {
      bumpCard?.classList.toggle('is-selected', Boolean(bumpCheckbox?.checked));
      compCard?.classList.toggle('is-selected', Boolean(compCheckbox?.checked));
      selectVariant();
    });
  });
});

/* 08/10/2026: foto da variante (mes/letra) ao clicar; lote 77 */
window.amadaIrParaFotoDaVariante=function(root,v){try{var src=v&&(v.featured_media&&v.featured_media.preview_image&&v.featured_media.preview_image.src||v.featured_image&&v.featured_image.src);if(!src||!root.amadaGoToSlide)return;var nome=String(src).split("?")[0].split("/").pop();var slides=[].slice.call(root.querySelectorAll("[data-gallery-slide]"));for(var i=0;i<slides.length;i++){var img=slides[i].querySelector("img");var s=img&&(img.getAttribute("src")||"");if(s&&s.split("?")[0].split("/").pop()===nome){root.amadaGoToSlide(Number(slides[i].dataset.gallerySlide));return}}}catch(e){}};
